// =============================================================================
//  Copyright : 2021-2021 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Andreas Hesse
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : Analytics: package
// =============================================================================
import React from 'react';
import { loadLazy } from 'uix/parts';
export const AnalyticsOverview = loadLazy(()=>import(/* webpackChunkName: 'analytics' */ './analytics_overview'));
export const AnalyticsUsage = loadLazy(()=>import(/* webpackChunkName: 'analytics' */ './analytics_usage'));
export const AnalyticsVisitors = loadLazy(()=>import(/* webpackChunkName: 'analytics' */ './analytics_visitors'));
export const SessionDbExplorer = loadLazy(()=>import(/* webpackChunkName: 'analytics' */ './session_overview'));
export const UserAgentsOverview = loadLazy(()=>import(/* webpackChunkName: 'analytics' */ './ua_overview'));
export const UserAgentsManual = loadLazy(()=>import(/* webpackChunkName: 'analytics' */ './ua_manual'));
